export default function AccountPlaneIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1235 8.46414L18.8867 5.71414C20.0824 5.02378 21.6114 5.43347 22.3017 6.6292C22.9921 7.82493 22.5824 9.35391 21.3867 10.0443L17.9058 12.054C17.6427 12.2058 17.4629 12.4691 17.4172 12.7694L16.5978 18.1492C16.5521 18.4496 16.3723 18.7128 16.1092 18.8647L14.3405 19.8859C13.7278 20.2396 12.9516 19.8627 12.8507 19.1625L12.504 16.7562C12.4031 16.056 11.6269 15.679 11.0142 16.0328L7.6683 17.9646C7.32186 18.1646 6.88956 18.1389 6.56925 17.8993L2.21349 14.6406C1.63864 14.2105 1.6908 13.3328 2.31253 12.9738L3.92804 12.0411C4.25606 11.8517 4.66294 11.8639 4.97903 12.0726L5.81354 12.6236C6.12963 12.8323 6.5365 12.8445 6.86453 12.6551L9.7934 10.9641M14.1235 8.46414L9.98525 6.69645C9.6958 6.5728 9.36502 6.59266 9.09243 6.75004L7.4626 7.69102C6.81882 8.06271 6.79125 8.98196 7.41161 9.39156L9.7934 10.9641M14.1235 8.46414L9.7934 10.9641"
        stroke="#0068FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
